export enum ARTWORK_BAG_STATUS {
  IDLE = 'idle',
  NOT_ADDED = 'notAdded',
  LOADING = 'loading',
  ADDED = 'added',
}
